<template>
    <div>
      <h2>人员信息</h2>
      
      <!-- 添加/编辑表单 -->
      <!-- <button @click="openDialog(null)">新增数据</button> -->
       <div style="text-align: left;margin-top: 10px;margin-bottom: 5px;">
        <el-button type="primary" @click="openDialog(null)" round >新增数据</el-button>
    </div>
   
      <!-- 产品列表 -->
      <el-table
    :data="users"
    style="width: 100%;"
    :row-class-name="tableRowClassName">
    <el-table-column
      prop="date"
      label="日期"
      width="180">
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
      width="180">
    </el-table-column>
    <el-table-column
      prop="code"
      label="编码">
    </el-table-column>
    <el-table-column
      prop="remark"
      label="备注">
    </el-table-column>
    <el-table-column
      label="操作">
      <template slot-scope="scope">
        <el-button size="mini" @click="openDialog(scope.row)">Edit</el-button>
        <el-button size="mini" type="danger" @click="deleteProduct(scope.row.id)">Delete</el-button>
      </template>
    </el-table-column>
        </el-table>

        <!-- 弹窗 -->
     <div v-if="isDialogVisible" class="dialog-mask">
        <div class="dialog-content">
            <h3 style="margin-bottom: 20px;">{{ isEditMode ? '修改用户' : '新增用户' }}</h3>
            <div class="form-group">
                <label style="display: inline;">姓名</label>
                <el-input placeholder="请输入姓名" v-model="currentUser.name" style="display: inline;margin-left: 5px; " 
                 clearable required>
                </el-input>
            </div>
            <div class="form-group">
                <label style="display: inline;">编码</label>
                <el-input placeholder="请输入内容" v-model="currentUser.code" style="display: inline;margin-left: 5px; "  clearable required></el-input>
            </div>
            <div class="form-group">
                <label style="display: inline;">密码</label>
                <el-input placeholder="请输入密码" v-model="currentUser.psw" style="display: inline;margin-left: 5px; " show-password required></el-input>
            </div>
            <div class="form-group">
                <label style="display: inline;">备注</label>
                <el-input v-model="currentUser.remark" style="display: inline;margin-left: 5px; " ></el-input>
            </div>
            <div class="button-group">
                <el-button size="mini" round @click="saveProduct">确认</el-button>
                <el-button size="mini" round @click="closeDialog">取消</el-button>
                
            </div>
        </div>
     </div>
    </div>
</template>
   
  <script>
  import axios from 'axios';
   
  export default {
    data() {
      return {
        users: [],
        currentUser: { id: 0, name: '',psw:'',code:'',remark:''},
        isDialogVisible: false,
        isEditMode: false,
        formData: {
            id: null,
            name: '',
            age: null
        },
      };
    },
    created() {
      this.loadUsers();
    },
    methods: {
      async loadUsers() {
        try {
          const response = await axios.get('http://localhost:5432/api/v1/userinfo/getusersall');
          this.users = response.data;
        } catch (error) {
          console.error('获取人员列表失败:', error);
        }
      },
   
      async saveProduct() {
        // console.log(this.currentUser.psd,'密码')
        if (!this.currentUser.name.trim()) {
            alert("用户名为空")
        }
        else if(!this.currentUser.code.trim())
        {
            alert("编码为空")
        }
        else if(!this.currentUser.psw.trim()||this.currentUser.psw.length<6)
        {
            alert("密码不能为空且长度最少为6")
        }
        else{
            try {
            if (this.currentUser.id) {
                // 更新现有产品
                await axios.put(`http://localhost:5432/api/v1/userinfo/PutUserInfo/${this.currentUser.id}`, this.currentUser);
            } else {
                // console.log(this.currentUser)
                // 创建新产品
                await axios.post('http://localhost:5432/api/v1/userinfo/PostUser', this.currentUser);
            }
            this.currentUser = { id: null, name: '',psw:'',code:'',remark:''};
            this.loadUsers();
            this.isDialogVisible=false;
            } catch (error) {
            console.error('保存失败:', error);
            }
        }
       
      },
   
      editProduct(product) {
        this.currentUser = { ...product };
      },
   
      async deleteProduct(id) {
        alert(id)
        try {
          await axios.delete(`http://localhost:5432/api/v1/userinfo/DeleteProduct/${id}`);
          this.loadUsers();
          this.currentUser = { id: null, name: '',code:'',remark:''};
        } catch (error) {
          console.error('删除失败:', error);
        }
      },
      
      openDialog(item) {
      this.isDialogVisible = true
      this.isEditMode = !!item
      
      // 深拷贝避免直接修改原数据
      if (item) {
        this.currentUser = { ...item }
      } else {
        this.currentUser = { id: null, name: '',code:'',remark:'',psw:''};
      }
    },
 
    closeDialog() {
      this.isDialogVisible = false
    },
 
    // handleSubmit() {
    //   if (this.isEditMode) {
    //     // 修改逻辑
    //     const index = this.users.findIndex(item => item.id === this.currentUser.id)
    //     if (index !== -1) {
    //       this.dataList.splice(index, 1, { ...this.currentUser })
    //     }
    //   } else {
    //     // 新增逻辑
    //     this.formData.id = Date.now() // 简单生成唯一ID
    //     this.dataList.push({ ...this.formData })
    //   }
      
    //   this.closeDialog()
    // }
    },
  };
  </script>
<style>
    .dialog-mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
    }
     
    .dialog-content {
      background: #545C64;
      padding: 20px;
      border-radius: 8px;
      min-width: 350px;
      margin-top: 10px;
    }
     
    .form-group {
      margin-bottom: 15px;
      text-align: left;
    }
     
    .form-group label {
      display: block;
      margin-bottom: 5px;
    }
    .form-group input {
     width: 260px;
    }
    .button-group {
      margin-top: 15px;
      text-align: right;
    }
     
    .button-group button {
      margin-left: 10px;
    }
    </style>